import React, {
  Fragment,
  useState,
  useEffect,
  useMemo,
  useLayoutEffect,
} from "react";
import { Row, Col, Typography, message, Button, Form } from "antd";
import { useForm } from "react-hook-form";
import { InputField, InputSwitch } from "../../../atoms/FormElement";
import { InputNumberFieldV2 as InputNumberField } from "../../../atoms/FormElement/InputNumberField";
import { PopupConfirm } from "../../../atoms/Popup";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { getBookingDetail, updateBooking } from "../ducks/actions";
import { Modal } from "../../../modules/BookingForm/components";
import { PlusOutlined } from "@ant-design/icons";
import { v4 as uuidv4 } from "uuid";
const { Text } = Typography;

const AddPaymentPlan = (props) => {
  const { plansData, onClose, setPlansValue, sendPlanApi, furnished } = props;
  // redux states


  let initialState = {
    modalPayload: {
      iKey: "",
      title: "",
      open: false,
      extraText: "",
      width: "65%",
    },
  };
  // redux states
  const { bookingDetails, bookingForm } = useSelector((state: any) => state.newBooking);
  // Working copy for editing

  const { leaseId = bookingDetails.leaseId } = useParams();
  const [isLoading, setIsLoading] = useState(false);

  const dispatch: any = useDispatch();
  const [{ modalPayload }, setState] = useState(initialState);

  const updateState = (state: {}) =>
    setState((prevState: any) => ({ ...prevState, ...state }));

  const {
    control,
    setValue,
    getValues,
  } = useForm();

  let customPaymentPlanExist = bookingDetails.customPaymentPlan
    ? Object.keys(bookingDetails.customPaymentPlan)
    : [];
  const modifiedPlans = useMemo(() => {
    if (!plansData || plansData.length === 0) return [];

    let basePlans = plansData.map((plan, idx) => ({
      ...plan,
      _key: plan.planId || uuidv4(), // ✅ use planId if available, else uuid
    }));

    if (customPaymentPlanExist?.length > 0) {
      basePlans.push({
        ...bookingDetails.customPaymentPlan,
        _key: "custom-" + uuidv4(), // ✅ unique key for custom plan
      });
    }

    return basePlans;
  }, [plansData, bookingDetails.customPaymentPlan]);

  const [addPlans, setAddPlans] = useState(modifiedPlans);

  const persistPaymentPlan = async (updatedPlanData) => {
    let body = {
      paymentPlan: updatedPlanData,
    };
    try {
      const response = await dispatch(updateBooking({ leaseId, body }));
      if (response) {
        await dispatch(getBookingDetail(leaseId));
      }
    } catch (error) {
      console.log(error);
    }
  };
  const savePaymentPlan = () => {
    const addPayments = getValues("addpayment");
    PopupConfirm({
      title: `Are you sure you want to update the plans?`,
      content: "",
      onOk: () => {
        if (addPayments?.length > 0) {
          const finalPayments = addPayments.filter(
            (p) => p?.annualRent && p?.annualRent > 0
          );
          //  for persist payment plan changes
          persistPaymentPlan(finalPayments);
          setPlansValue(finalPayments);
          onClose();
          message.success("Saved");
        }
      },
      okText: "Confirm",
    });
  };

  const sendPaymentPlan = () => {
    const addPayments = getValues("addpayment");

    PopupConfirm({
      title: `Are you sure you want to send plans for approval?`,
      content: "",
      onOk: async () => {
        if (addPayments?.length > 0) {
          const finalPayments = addPayments.filter(
            (p) => p?.annualRent && p?.annualRent > 0
          );

          sendPlanApi([...finalPayments]);
        }
      },
      okText: "Confirm",
    });
  };

  const setPaymentScheduler = async (item = null) => {
    try {
      setIsLoading(true);

      let payload: any = { ...modalPayload };
      payload = {
        iKey: "3",
        extraText: "",
        title: "Custom Payment Schedule",
        width: "65%",
      };
      const addPayments = getValues("addpayment");

      // find index of existing customPayment Plan
      const index = addPayments.findIndex(
        (item) => item?.isCustomPaymentPlan === "yes"
      );

      let leaseStartDate = bookingDetails?.leaseTerms?.leaseStartDate
        ? bookingDetails?.leaseTerms?.leaseStartDate?.slice(0, 10)
        : bookingForm?.leaseTerms?.leaseStartDate?.slice(0, 10);
      let leaseEndDate = bookingDetails?.leaseTerms?.leaseEndDate
        ? bookingDetails?.leaseTerms?.leaseEndDate?.slice(0, 10)
        : bookingForm?.leaseTerms?.leaseEndDate?.slice(0, 10);

      if (item) {
        item["leaseStartDate"] = leaseStartDate;
        item["leaseEndDate"] = leaseEndDate;
        item["furnished"] = furnished;
        item["newPlan"] = "true";

        let body = {
          customPaymentPlan: item,
        };
        const response = await dispatch(updateBooking({ leaseId, body }));

        if (response) {
          await dispatch(getBookingDetail(leaseId));
          // message.success(response.data.message);

          let modalOption = true;
          updateState({
            modalPayload: { ...payload, ...{ open: modalOption } },
          });
          setIsLoading(false);

          // if custom payment plan already exist then find and update the same plan
          if (item) {
            if (index !== -1) {
              // replace existing item
              addPayments[index] = item;
            } else {
              // add new item
              addPayments.push(item);
            }
            setAddPlans(addPayments);
          }
        }
      }
    } catch (error) {
      setIsLoading(false);
      console.log(error);
      message.error(error.response?.data?.error || error.response?.data?.message);
    }
  };

  const showSwitchButton = (isCustomPaymentPlan) => {
    const el = document.getElementById("customPaymentPlanAnnualRent") as HTMLInputElement | null;
    const annualRentValue: number | null = el ? Number(el.value) : null;

    if (isCustomPaymentPlan === "yes") {
      return Number(annualRentValue);
    }
  };

  const sendApprovalButton = () => {
    const addPayments = getValues("addpayment");
    let result = addPayments?.find((item) => item?.annualRent > 0 && item?.installments > 0);
    return result && Object.keys(result)?.length > 0 ? false : true;
  };

  const onChangesHandler = (value, index) => {
    let tempPlan = [...addPlans];
    tempPlan[index] = {
      ...tempPlan[index],
      annualRent: value,
    };
    setAddPlans(tempPlan);
  };
  const AddCustomePaymentPlan = () => {
    let payload: any = { ...modalPayload };
    payload = {
      iKey: "3",
      extraText: "",
      title: "Add Custom Payment Plan",
      width: "65%",
    };

    updateState({ modalPayload: { ...payload, ...{ open: true } } });
  };
  return (
    <>
      <Form layout="vertical" name="addplansForm" className="bf-main" scrollToFirstError>
        <Row gutter={[24, 24]}>
          <Col span={24}>
            <Text className="fontWeight600 ag-default mb-1 ft-main-label">Payment Plans</Text>
          </Col>

          <Col span={12}>
            <Text className="fontWeight600 ag-default mb-1">NO OF PAYMENTS</Text>
          </Col>
          <Col span={4}>
            <Text className="fontWeight600 ag-default mb-2">ANNUAL RENT</Text>
          </Col>
          <Col span={4}>
            <Text className="fontWeight600 ag-default mb-2">NUMBER OF YEARS</Text>
          </Col>
          <Col span={4}>
            <Text className="fontWeight600 ag-default mb-2">SECURITY DEPOSIT</Text>
          </Col>
        </Row>
        <Row gutter={[16, 24]} className="bf-main">
          <Col span={24} className="ft-divider" />
          {[...addPlans]?.map((item, index) => (
            <Fragment key={item?._key + index}>
              <Col span={12}>
                <Row align="middle" justify="space-between">
                  <Row gutter={16} wrap={false}>
                    <Col>
                      <Text
                        className="ag-dark fontWeight600"
                        style={{ fontSize: "14px" }}
                      >
                        {item.installments}{" "}
                        {item?.isCustomPaymentPlan
                          ? "Cheques (Custom)"
                          : "Cheques"}
                      </Text>
                    </Col>

                    <Col>
                      <InputField
                        classes="fm-input-hidden"
                        fieldname={`addpayment[${index}]`}
                        control={control}
                        initValue={item}
                        iProps={{ readOnly: true, type: "hidden" }}
                      />

                      {((item && item?.annualRent > 0) ||
                        showSwitchButton(item?.isCustomPaymentPlan) > 0) && (
                        <div
                          style={
                            !item?.isCustomPaymentPlan
                              ? {}
                              : { marginTop: "0px" }
                          }
                        >
                          <InputSwitch
                            isRequired
                            fieldname={`addpayment[${index}].checked`}
                            control={control}
                            valueGot={!!item?.checked}
                            setValue={setValue}
                          />
                        </div>
                      )}
                    </Col>
                  </Row>

                  {item?.isCustomPaymentPlan && (
                    <Button
                      style={{
                        margin: "4px",
                        borderRadius: "6px",
                      }}
                      type="primary"
                      className="cc-fotter_next-button"
                      htmlType="button"
                      onClick={() => AddCustomePaymentPlan()}
                    >
                      Edit
                    </Button>
                  )}
                </Row>
              </Col>

              <Col span={4}>
                <InputNumberField
                  isRequired
                  format="currency"
                  fieldname={`addpayment[${index}].annualRent`}
                  control={control}
                  onChange={(value) => onChangesHandler(value, index)}
                  defaultValue={item.annualRent ?? 0}
                  rules={{ required: "Please enter annual rent" }}
                  disabled={item?.isCustomPaymentPlan}
                />
              </Col>

              <Col span={4}>
                <InputNumberField
                  isRequired
                  fieldname={`addpayment[${index}].noOfYear`}
                  control={control}
                  defaultValue={item?.noOfYear || 1}
                  inputNumberProps={{
                    min: 1,
                    max: 12,
                  }}
                  onChange={(value) => {
                    let tempPlan = [...addPlans];
                    tempPlan[index] = {
                      ...tempPlan[index],
                      noOfYear: value,
                    };
                    setAddPlans(tempPlan);
                  }}
                  rules={{ required: "Please enter total amount" }}
                  disabled={item?.isCustomPaymentPlan}
                />
              </Col>
              <Col span={4}>
                <InputNumberField
                  isRequired
                  format="currency"
                  fieldname={`addpayment[${index}].securityDeposit`}
                  control={control}
                  defaultValue={item?.securityDeposit || 0}
                  onChange={(value) => {
                    let tempPlan = [...addPlans];
                    tempPlan[index] = {
                      ...tempPlan[index],
                      securityDeposit: value,
                    };
                    setAddPlans(tempPlan);
                  }}
                  rules={{ required: "Please enter total amount" }}
                  disabled={item?.isCustomPaymentPlan}
                />
              </Col>
            </Fragment>
          ))}
        </Row>

        {customPaymentPlanExist?.length == 0 && (
          <Row>
            <Col span={24}>
              <Button
                type="dashed"
                // className="p-0"
                onClick={() => AddCustomePaymentPlan()}
                htmlType="button"
                icon={<PlusOutlined />}
                block={true}
              >
                <Text
                  className="ag-primary fontWeight600"
                  style={{ fontSize: "14px" }}
                >
                  Add Custom Payment Plan
                </Text>
              </Button>
            </Col>
          </Row>
        )}
        <Row gutter={24} style={{ marginTop: "20px" }}>
          <Col span={24}>
            <Row gutter={24} justify="end">
              <Col>
                <Button
                  size="large"
                  className="cc-fotter_back-button"
                  onClick={() => onClose()}
                >
                  Cancel
                </Button>
              </Col>

              {bookingDetails?.paymentPlanApproval != "disable" && (
                <Col>
                  <Button
                    size="large"
                    // disabled={
                    //   !isDirty || bookingDetails?.paymentPlanApproval == "sent"
                    // }
                    disabled={sendApprovalButton()}
                    type="primary"
                    className="cc-fotter_next-button"
                    htmlType="button"
                    onClick={() => sendPaymentPlan()}
                  >
                    {bookingDetails?.paymentPlanApproval == "sent"
                      ? "Sent"
                      : "Send"}{" "}
                    for approval
                  </Button>
                </Col>
              )}
              <Col>
                <Button
                  disabled={bookingDetails?.paymentPlanApproval != "disable"}
                  size="large"
                  type="primary"
                  className="cc-fotter_next-button"
                  htmlType="button"
                  onClick={() => savePaymentPlan()}
                >
                  Save
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      </Form>

      <Modal
        className="bd-modal"
        updateState={updateState}
        modalPayload={modalPayload}
        isCustomePaymentSchedule={true}
        setPaymentScheduler={setPaymentScheduler}
        customePlanLoading={isLoading}
      />
    </>
  );
};
export default AddPaymentPlan;
